import {ClientId} from 'notebook/ELNConstants';
import {Format} from 'notebook/mediocre/formatted-text/FormattersConstants';
import {Table} from 'notebook/tables/TableConstants';

export const TYPE_CRITICAL = 'CRITICAL';
export const TYPE_PAUSE = 'PAUSE';

export const STEP_TYPES = [TYPE_CRITICAL, TYPE_PAUSE];
export const INSERT_SYMBOL = 'INSERT_SYMBOL';
export const INSERT_WELL_PLATE = 'INSERT_WELL_PLATE';

// Editor constants
export const AGGREGATE_TIME = 'AGGREGATE_TIME';

export enum StepLevel {
  HEADER = 'HEADER',
  STEP = 'STEP',
  DESC = 'DESC',
  TABLE = 'TABLE',
  IMAGE = 'IMAGE',
  TIMER = 'TIMER',
}

export enum EditorKey {
  STEPS = 'steps',
  MATERIALS = 'materials',
  INTRO = 'intro',
  TITLE = 'title',
}

export type BaseStep<TIds> = {
  completed: boolean;
  creator_id: number;
  link_type: string;
  formats: Format;
  level: StepLevel;
  table: Table | null;
  image: {url: string} | null;
  text: string;
  timer: {milliseconds: number} | null;
  time_seconds: number | null;
  type: (typeof STEP_TYPES)[number] | null;
} & TIds;

export type Step = BaseStep<ClientId> & {
  stepCount: number;
};

export type ProtocolViewerStep = BaseStep<{id: number; cid?: string}>;
